export enum DeflistNode {
    List = 'dl',
    Term = 'dt',
    Desc = 'dd',
}

export const DeflistAttr = {
    Line: 'data-line',
} as const;
